import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "./assets/element-variables.scss";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
//vconsole - 移到最前以捕获所有日志
import VConsole from "vconsole";
window.addEventListener("DOMContentLoaded", () => {
  const user = JSON.parse(localStorage.getItem("user") || "{}");

  // 只有在移动端且用户ID匹配时才加载VConsole
  if (user.id === 751521644249605) {
    new VConsole();
  }
});
setTimeout(() => {
  console.log(navigator.userAgent);
}, 5000);
//剪贴板
import VueClipboard from "vue-clipboard2";
//懒加载
import VueLazyload from "vue-lazyload";
//国际化
import VueI18n from "vue-i18n";
Vue.use(VueI18n);
//axios
import axios from "axios";
import url from "./assets/url.js";
//网络设置
axios.defaults.baseURL = url;

//瀑布流
import waterfall from "vue-waterfall2";
Vue.use(waterfall);

//i18n
const i18n = new VueI18n({
  locale: "ZH", // 设置地区
  messages: {
    ZH: require("@/assets/languages/zh.js"),
    EN: require("@/assets/languages/en.js")
  },
  silentTranslationWarn: true
});
//剪贴板
Vue.use(VueClipboard);
Vue.use(VueLazyload, {
  preLoad: 1.3,
  observer: true,
  // lazyComponent: true,
  attempt: 1 // 加载图片数量
  // throttleWait:2000
});

import method from "@/assets/methods.js";
Vue.use(ElementUI);
Vue.prototype.$BaaS = require("minapp-sdk");
Vue.prototype.$method = method;
Vue.prototype.$axios = axios;
const EventBus = new Vue();
// 将 EventBus 添加到 Vue 原型上
Vue.prototype.$bus = EventBus;

Vue.config.productionTip = false;

import { loadScript } from "@paypal/paypal-js";
loadScript({ "client-id": "ATPNh7w97yHzpEP2Dlg-dJq5d2iAo8n7eNxumFK4GM8tE9NNHA0-03wV9xjOkPssI3GEeNScibyUUxVd" }) //测试用的clientid
  // loadScript({ "client-id": "AZCgMMrPmZpTAgFWFASBqAYpSf6Yva7smrDqqrI-V2d_rk_yhHDjY48kKbCHusKBOWB8crWHNd4MC258" }) //正式用的clientid
  .then((paypal) => {
    // start to use the PayPal JS SDK script
    Vue.prototype.$Paypal = paypal;
  })
  .catch((err) => {
    console.error("failed to load the PayPal JS SDK script", err);
  });
Date.prototype.format = function (fmt) {
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor(this.getMonth() + 3, 3), //季度
    S: this.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o) if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
  return fmt;
};
// 在 Vue 组件的 created 生命周期或 router 守卫中，手动管理历史记录
let historyStack = [];
window.$VUE = new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
  created() {
    this.$router.afterEach((to, from) => {
      // 将上一个路径添加到 historyStack 中
      if (from.path) {
        historyStack.push(from.path);
      }
    });
  },
  methods: {
    getPreviousPage() {
      // 获取上一个路径（如果存在的话）
      return historyStack.length > 0 ? historyStack[historyStack.length - 1] : null;
    }
  }
}).$mount("#app");
